import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FormDropdownProps } from './types';
import './FormDropdown.scss';

export const FormDropdown = <T extends { name: string }>({
  lable,
  selectedItem,
  items,
  error,
  className = '',
  action,
  required,
  disabled,
  placeholder = '',
  onSelect,
  onActionClick,
}: FormDropdownProps<T>) => {
  const getSubProjectClickHandler = (item: T) => () => onSelect(item);
  return (
    <div className={`d-flex flex-column form-dropdown ${className}`}>
      <label className="form-label">
        {lable}
        {required && <span className="mx-1">*</span>}
      </label>
      <Dropdown>
        <Dropdown.Toggle className="shadow-none" disabled={disabled}>
          <span>{selectedItem || placeholder}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="actions-dropdown py-2">
          {action && (
            <Dropdown.Item className="action-item" onClick={onActionClick}>
              {action}
            </Dropdown.Item>
          )}
          {items.map((task, i) => (
            <Dropdown.Item
              key={`${task.name}-${i}`}
              className={`${selectedItem === task.name ? 'active' : ''}`}
              onClick={getSubProjectClickHandler(task)}
            >
              {task.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
        {error && (
          <span className="error-text">
            {typeof error === 'object' ? error.join(', ') : error}
          </span>
        )}
      </Dropdown>
    </div>
  );
};
